import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app.service';

@Component({
  selector: 'app-hazards-account-risk-matrix',
  templateUrl: './hazards-account-risk-matrix.component.html',
  styleUrls: ['./hazards-account-risk-matrix.component.scss']
})
export class HazardsAccountRiskMatrixComponent implements OnInit {

  constructor(public app: AppService) { }

  ngOnInit() {
  }

}
